/**
 * AgentContextCard - Entry point into the project's knowledge base
 *
 * The knowledge base (project_knowledge_entry) replaced free-text
 * agentContext editing here. This card now only links to it and shows how
 * many entries are pinned (always injected into the agent's prompt).
 */

import { useNavigate } from 'react-router-dom';
import { Bot, ChevronRight, Pin } from 'lucide-react';
import { Card } from '../common';

interface AgentContextCardProps {
  projectId: string;
  pinnedCount: number;
}

export function AgentContextCard({ projectId, pinnedCount }: AgentContextCardProps) {
  const navigate = useNavigate();

  return (
    <Card>
      <button
        onClick={() => navigate(`/projects/${projectId}/knowledge`)}
        className="w-full flex items-center justify-between gap-3"
      >
        <div className="flex items-center gap-3">
          <Bot className="w-4 h-4 text-indigo-600 dark:text-indigo-400" />
          <div className="text-left">
            <h3 className="text-[1rem] leading-[140%] font-semibold text-gray-900 dark:text-white">
              Knowledge Base
            </h3>
            <p className="font-body-base text-gray-500 dark:text-white-500 flex items-center gap-1.5 mt-1">
              {pinnedCount > 0 ? (
                <>
                  <Pin className="w-3.5 h-3.5" />
                  {pinnedCount} {pinnedCount === 1 ? 'entry' : 'entries'} pinned to the agent&apos;s prompt
                </>
              ) : (
                'No context configured yet. Add entries to help the agent understand this project.'
              )}
            </p>
          </div>
        </div>
        <ChevronRight className="w-5 h-5 text-gray-400 shrink-0" />
      </button>
    </Card>
  );
}
